import React, { useEffect, useState } from "react";
import { useRemoteRenderContext } from "../../../../classes/contexts/RemoteRenderContext";
import { PLANNING_STATES } from "../../../../classes/enums/PlanningStateEnum";
import Button from "../../../../components/button/Button";
import LabeledSelect from "../../../../components/select/LabeledSelect";
import "../../vertebraManagementPopups/VertebraManagement.css";

const AddLandmark = ({ onClose }) => {
  const { client: renderClient } = useRemoteRenderContext();

  const [availableLandmarks, setAvailableLandmarks] = useState([]);
  const [selectedLandmark, setSelectedLandmark] = useState("");
  const [selectedPointId, setSelectedPointId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAvailableLandmarks = async () => {
      try {
        setIsLoading(true);
        const data = await renderClient.getAvailableLandmarks(
          PLANNING_STATES.VALIDATE
        );
        setAvailableLandmarks(data);

        // Set the first landmark as default, if any are available
        if (data && data.length > 0) {
          setSelectedLandmark(data[0][0]); // landmark name
          setSelectedPointId(data[0][1]); // point ID
        }
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };

    fetchAvailableLandmarks();
  }, [renderClient]);

  // Generate landmark items for dropdown
  const landmarkItems = availableLandmarks.map(([landmarkName, pointId]) => ({
    value: `${landmarkName}|${pointId}`, // Combine name and ID
    label: landmarkName,
  }));

  const handleLandmarkChange = event => {
    const value = event.target.value;
    const [landmarkName, pointId] = value.split("|");
    setSelectedLandmark(landmarkName);
    setSelectedPointId(parseInt(pointId, 10));
  };

  const handleAddLandmark = React.useCallback(async () => {
    if (!selectedLandmark || selectedPointId === null) {
      return;
    }

    try {
      await renderClient.addLandmark(
        PLANNING_STATES.VALIDATE,
        selectedLandmark,
        selectedPointId
      );
      onClose?.();
    } catch (error) {}
  }, [selectedLandmark, selectedPointId, renderClient, onClose]);

  if (isLoading) {
    return (
      <div className="vertebra-management-container">
        <div>Loading available landmarks...</div>
      </div>
    );
  }

  if (!landmarkItems.length) {
    return (
      <div className="vertebra-management-container">
        <div>No landmarks available</div>
      </div>
    );
  }

  const isSingleLandmark = landmarkItems.length === 1;

  return (
    <div className="vertebra-management-container">
      <LabeledSelect
        label="Select Landmark"
        items={landmarkItems}
        selectedItem={`${selectedLandmark}|${selectedPointId}`}
        onChange={handleLandmarkChange}
        disable={isLoading || isSingleLandmark}
      />
      <div className="vertebra-management-actions">
        <Button
          className="App-button"
          value="Add Landmark"
          onClick={handleAddLandmark}
          disabled={!selectedLandmark}
        />
      </div>
    </div>
  );
};

export default AddLandmark;
